import { BackendError } from 'api/api-client/dtos';

export class HttpError extends Error {
  constructor(
    public status: number,
    public response: BackendError,
    public config: { url: string; method: string; data: unknown },
  ) {
    super(response.message);
    this.name = this.constructor.name;

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, HttpError.prototype);
  }

  json() {
    return {
      status: this.status,
      response: this.response,
      config: this.config,
    };
  }
}
